/**
 * Customized to pass a widget container style to the first, second, and third
 * slots, removing the need to pass an `ItemWrap` component that would otherwise
 * introduce an extra wrapper div.
 *
 * This allows widgets to apply container-level styles directly, rather than
 * relying on an external wrapper.
 *
 * See the ContentRecommendation widget for an example of how the container
 * styling is applied.
 */

import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import { layoutMainSX, widgetContainerSx } from '@/components/layouts/styles/main';
import { Layout } from '@/data/types/Layout';
import { Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC } from 'react';

export const TripleStack: FC<{ layout: Layout }> = ({ layout }) => {
	const {
		dimensions: { contentSpacing },
	} = useTheme();

	return layout ? (
		<>
			<LayoutSlot slot={layout.slots.header} />
			<Stack
				component="main"
				gap={contentSpacing}
				alignItems="center"
				sx={layoutMainSX(layout.slots.first?.length || 0)}
			>
				<LayoutSlot slot={layout.slots.first} widgetContainerSx={widgetContainerSx} />
				<LayoutSlot slot={layout.slots.second} widgetContainerSx={widgetContainerSx} />
				<LayoutSlot slot={layout.slots.third} widgetContainerSx={widgetContainerSx} />
				<LayoutSlot slot={layout.slots.footer} />
			</Stack>
		</>
	) : null;
};
